import { httpRequest } from "@services/http";

/**
 * The journeys defined in Journey Steps (MPN-1573).
 *
 * The Contract form's Journey picker reads this rather than keeping its own list, so a
 * journey added in Journey Steps is selectable on a contract with no further work — which
 * the ticket asks for explicitly.
 */
export interface JourneyOption {
  id: number;
  name: string;
  industry?: string | null;
  is_master?: boolean;
}

export class CommandGetJourneys {
  async run(): Promise<JourneyOption[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/journeys/`;
    const response = await httpRequest<any>(url, { method: "GET" });
    const rows = Array.isArray(response) ? response : (response?.results ?? []);
    return rows.map((j: any) => ({
      id: j.id,
      name: j.name ?? "",
      industry: j.industry ?? null,
      is_master: j.is_master ?? false,
    }));
  }
}
